import { Button, IconCamera, TextField } from "@wilco/ui";
import { useState, type Ref, type SubmitEvent } from "react";
import { t } from "../i18n.ts";
import { canUseCamera } from "./camera.ts";
import { ScanDialog } from "../shell/ScanDialog.tsx";

/**
 * Поле скана экрана склада: сканер DS2278 работает как клавиатура и
 * кончает код Enter; рядом кнопка камеры на телефоне. Поле очищается сразу
 * после кода: сканер набирает быстрее отрисовки, и следующий код не
 * склеится с прошлым.
 */
export function ScanBar({
  onScan,
  placeholder,
  autoFocus,
  inputRef,
}: {
  onScan: (code: string) => void;
  placeholder: string;
  autoFocus?: boolean;
  inputRef?: Ref<HTMLInputElement>;
}) {
  const [code, setCode] = useState("");
  const [camera, setCamera] = useState(false);
  const withCamera = canUseCamera();

  const submit = (e: SubmitEvent) => {
    e.preventDefault();
    const value = code.trim();
    setCode("");
    if (value) onScan(value);
  };

  // Диалог камеры вне формы: события React идут сквозь портал к родителю, и
  // отправка формы диалога отправила бы и это поле.
  return (
    <>
    <form className="scanbar" role="search" onSubmit={submit}>
      <TextField
        ref={inputRef}
        label={t("scan.label")}
        hideLabel
        variant="scan"
        placeholder={placeholder}
        value={code}
        onChange={(e) => setCode(e.target.value)}
        autoFocus={autoFocus}
        autoComplete="off"
        autoCapitalize="characters"
        spellCheck={false}
        enterKeyHint="go"
        className="scanbar-field"
      />
      {withCamera ? (
        <Button variant="create" size="icon" className="scanbar-camera" aria-label={t("camera.open")} onClick={() => setCamera(true)}>
          <IconCamera />
        </Button>
      ) : null}
    </form>
    {withCamera ? <ScanDialog open={camera} onOpenChange={setCamera} onScan={onScan} /> : null}
    </>
  );
}
